import React, { FC } from 'react'
import { ProductDownloadWrapper, ThankYouWrapper } from './style'

//* utils
import { ASSETS } from '../../../../constants/assets'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { renderMarketoOrIframe } from '../../../../utils/cn.utils'
import ImgUtil from '../../../../utils/img.utils'
import marketoForm from '../../../global/marketo'

//* components
import ContentBlock from '../../../global/contentBlock'
import GlobalContainer from '../../../global/globalContainer'
import ProductDownload from '../../../global/productDownload'
import ResourceRow from '../../../global/resourceRow'
import SEOTags from '../../../global/seoTags'
import Slider from '../../../global/slider'
import Tiles from '../../../global/tiles'
import Typography from '../../../global/typography'
import VideoSpotlight from '../../../global/videoSpotlight'
import WrapperImage from '../../../global/wrapperImage'

type Props = {
  data: any
  locale: string
  path: string
}

export const Modules: FC<Props> = ({ data, locale, path }) => {
  let h1Title = ''
  const mainImage = {
    altText: 'UiPath',
    url: '/',
  }

  const dynamicPageContent = data.flexSection?.map((module: any, i: number) => {
    switch (module.__typename) {
      case ModuleNames.TILES:
        return <Tiles data={module} key={`page-component--${i}`} />

      case ModuleNames.PRODUCT_DOWNLOAD_COMPONENT:
        return <ProductDownload data={module} key={`page-component--${i}`} />

      case ModuleNames.SLIDER:
        return <Slider data={module} key={`page-component--${i}`} />

      case ModuleNames.VIDEO_SPOTLIGHT:
        return <VideoSpotlight data={module} useCase={'horizontal'} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.RESOURCE_ROW:
        return <ResourceRow data={module} key={`page-component--${i}`} locale={locale} />

      case ModuleNames.HERO:
        h1Title = module.headline || ''
        mainImage.altText = module.backgroundAsset?.altText || 'UiPath'
        mainImage.url = module.backgroundAsset?.image?.file?.url || '/'
    }
  })
  const cnLocale = LocaleCodes.CHINESE.code
  const renderIframe = () => {
    if (data.cnFormOverride && locale === cnLocale) {
      // Return the iframe content directly
      return renderMarketoOrIframe({
        defaultLocale: locale,
        marketoFormData: marketoForm,
        cnFormOverride: data.cnFormOverride,
      })
    }
    // Return null if conditions are not met
    return null
  }
  const renderDownloadPage = () => {
    return (
      <GlobalContainer>
        <ProductDownloadWrapper>
          <div className="ProductDownload__Download-Container">
            <Typography type="header1" className="ProductDownload__Heading">
              {h1Title}
            </Typography>

            {dynamicPageContent}
          </div>

          <div className="ProductDownload__Featured-Image-Container">
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(ASSETS.PRODUCT_MACARONI, `width=750`)}
              alt="Half moon shape"
              className="ProductDownload__Featured-Image-Macaroni"
              width={588}
              height={588}
              threshold={650}
            />

            <WrapperImage
              className="ProductDownload__Featured-Image-File"
              src={ImgUtil.getResizedImageUrl(mainImage.url, `width=750`)}
              alt={mainImage.altText}
              width={750}
              height={750}
              threshold={650}
            />
          </div>
        </ProductDownloadWrapper>
        {renderIframe()}
      </GlobalContainer>
    )
  }

  const renderThankYouPage = () => {
    return (
      <ThankYouWrapper>
        <>
          {dynamicPageContent}
          {renderIframe()}
        </>
      </ThankYouWrapper>
    )
  }

  return (
    <div data-cy={'ProductDownloadPage'}>
      <SEOTags
        seoMetadata={data.seoMetadata}
        slug={data.slug || ''}
        path={path}
        locale={locale}
        siteSection="Product Download"
      />

      {data.useCase === 'Product Download Thank You' ? renderThankYouPage() : renderDownloadPage()}
    </div>
  )
}
